// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__26Vhg","search":"Settings_search__1QMFH","filter":"Settings_filter__2B4R_"};